import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData, Helpers,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const openModal = (_, title, compont, dataRequest) => {
    toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
      toggle()
    }

    const handleClickShowModal = async (event) => {
        
        const { backgroundCode } = globalStates
        const { FormRequestGlobal } = Forms
        const { setFormState } = FormRequestGlobal
        const infoEvent = event._def

        // console.log('[useActions][handleClickShowModal] event ', event);
        console.log('[useActions][handleClickShowModal] event._def ', event._def);
        console.log('[useActions][handleClickShowModal] color ', infoEvent.ui.backgroundColor);

        await setFormState(prevState => ({
            ...prevState,
            idagenda: infoEvent.publicId,
        }))
        
        const { fetchAInfoEvent } = FetchData
        const { executeFetchInfoEvents } = fetchAInfoEvent
        
        await executeFetchInfoEvents()
        
        // Clasificacion por color de evento
        switch (infoEvent.ui.backgroundColor) {
            case backgroundCode.vehicle.pagoVehiculoAtrasado:{// Pagos de vehiculos
                openModal("", "", "event-section", {})
                break
            }  // Pagos de vehiculos
            case backgroundCode.vehicle.pagoVehiculoNormal:  {// Pagos de vehiculos
                openModal("", "", "event-section", {})
                break
            }
            case backgroundCode.vehicle.pagoVehiculoVerde: {
                openModal("", "", "event-section", {})
                break
            }
            case backgroundCode.vehicle.RenovacionSeguro: {// Renovacion de seguros
                openModal("", "", "insurance-section", {})
                break
            }
            case backgroundCode.vehicle.RenovacionGPS: {// Renovacion de seguros
                openModal("", "", "gps-section", {})
                break
            }
            default:
                break;
        }
    }

    const handleClickReturnModal = async () => {
        
        const {FormRequestModal:{onResetForm}} = Forms
        onResetForm()
        closeModal()
    }
    
    const handleCustomButtonClick = async () => {
        const {calendarRef} = globalStates

        const {getPreviousMonthDate, getNextMonthDate} = Helpers

        const {FormRequestGlobal:{setFormState}} =  Forms

        const {fetchAllEvents:{executeFetchAllEvents}} =  FetchData
        
        const formatter = new Intl.DateTimeFormat('en-CA');
        const formattedCalendarDate = formatter.format(calendarRef.current.getApi().getDate());
        const fecha_inicio = getPreviousMonthDate(formattedCalendarDate)
        const fecha_final = getNextMonthDate(formattedCalendarDate)

        await setFormState(prevState => ({
            ...prevState,
            fecha_acutal: formattedCalendarDate,
            fecha_inicio: fecha_inicio,
            fecha_final: fecha_final
        }))
        
        executeFetchAllEvents()
    
    }
    
    return Object.freeze({
        handleCustomButtonClick,

        handleClickShowModal,
        handleClickReturnModal
    })

}

const alertMessage = (res, toggle) => {


  if (res) {
      const { title, message} = res
      if (title === 'OK') {
          toast.success(message, {
              position: "top-right",
              theme: "colored"
          })
          toggle && toggle()
      } else {
          toast.warn(message, {
              position: "top-right",
              theme: "colored",
              autoClose: false,
          })
      }
  } else {
      toast.warn('Error interno, notifique a Soporte técnico!.', {
          position: "top-right",
          theme: "colored",
          autoClose: false,
      })
  }
}